import Loading from "../../../components/Loading"
import ProjectGrid from "../../../components/ProjectGrid"
const LotListComponent = ({ LotList }: any) => (
  <div className="pt-5 pb-5">
    {LotList?.length > 0 ? (
      <>
        <h2 className="fs-1 fw-bolder text-uppercase">Key Industrial Lots</h2>
        <p className="w-50 fs-4">
          Get your industrial real estate requirement satisfied in any major industrial hub in the Philippines.
        </p>
        <ProjectGrid
          object={LotList}
          link="/find-a-property/search?type=Industrial+Lots"
          linkText="VIEW OTHER INDUSTRIAL LOTS"
        />
      </>
    ) : (
      <Loading />
    )}
  </div>
);

export default LotListComponent;